<template>
  <div class="add-product-table" v-if="tableData != null ">
    <el-table
      ref="table"
      :data="tableData"
      max-height="580"
      style="width: 100%;margin-bottom: 20px;"
      row-key="nodeId"
      :expand-row-keys="expandKeys"
      lazy
      border
      :row-class-name="tableRowClassName"
      :load="load"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      :header-cell-style="{background:'#eef1f6'}"
      :cell-style="changeStyle"
    >
      <el-table-column
        prop="productInitListVO.alias"
        :label="$t('addConfigModule.productName')"
        :render-header="foo"
        align="left"
        min-width="200"
      >
        <template slot-scope="scope" v-if="scope.row.productInitListVO">
          <el-input
            style="display: inline-block; width: 100%; font-size: 10px;"
            v-model="scope.row.productInitListVO.alias"
            :placeholder="$t('addConfigModule.enterProductName')" @change="saveUserProductAlias(scope.row.productInitListVO)"
          />
        </template>
      </el-table-column>

      <el-table-column min-width="180">
        <!-- slot-scope="scope"不能删除，否则输入框失效 -->
        <template slot="header">
          <span>
            {{ $t('addConfigModule.productModel') }}
          </span>
          <el-input
            v-model="search"
            clearable
            size="mini"
            @keyup.native="searchEvent"
            :placeholder="$t('addConfigModule.QueryProductModelOrDescription')"
            @clear="clear"
            style="width:230px;line-height: 28px;  height: 28px;vertical-align: middle;"
          />
        </template>
        <template slot-scope="scope">
          <!-- <ProductNameFormation :scope="scope"></ProductNameFormation> -->
          <!--{{ scope.row.nodeName }}-->
          <PreciseProductNameFormation :scope="scope" />
        </template>
      </el-table-column>
      <el-table-column
        prop="productInitListVO.productDesc"
        :label="$t('addConfigModule.productDes')"
        :render-header="foo"
        width="200"
        align="left"
      >
        <template slot-scope="scope">
          <long-text
            :text="
              scope.row.productInitListVO &&
                scope.row.productInitListVO.productDesc
            "
            :switch-flg="switchFlgP"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="productInitListVO.productPrice"
        :label="$t('addConfigModule.priceRMB')"
        width="120"
        align="center"
        :formatter="priceFormat"
      >
        <!--增加价格高亮展示 mzy 2021年4月28日13:36:39-->
        <template slot-scope="scope">
          <span v-if="scope.row.productInitListVO != null">{{ priceFormat(scope.row,scope.column,scope.row.productInitListVO.productPrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('addConfigModule.theNumber')" width="120" align="center">
        <template slot-scope="scope" v-if="scope.row.productInitListVO">
          <el-input-number
            v-if="!scope.row.hasChildren"
            size="mini"
            controls-position="right"
            v-model="scope.row.productInitListVO.purchaseQuantity"
            :min="scope.row.productInitListVO.optionalType === 1 && scope.row.productInitListVO.subPropertyName === '主机' ? 1 : 0"
            :precision="0"
            :max="scope.row.productInitListVO.optionalType === 1 && scope.row.productInitListVO.subPropertyName === '主机' ? 1 : 99999"
            style="width: 80px"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="productInitListVO.productStatusStr"
        :label="$t('addConfigModule.status')"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <ProductStatusFomation :scope="scope.row && scope.row.productInitListVO" v-if="scope.row && scope.row.productInitListVO" />
        </template>
      </el-table-column>
      <el-table-column
        prop="productInitListVO.productType"
        :label="$t('addConfigModule.periodAfterPreparationTime')"
        width="100"
        align="center"
        v-if="!configurationGroup.isService"
      >
        <template slot-scope="scope">
          <ProductTypeFormation :scope="scope.row && scope.row.productInitListVO" v-if="scope.row && scope.row.productInitListVO" />
        </template>
      </el-table-column>
      <el-table-column
        prop="productInitListVO.productPscType"
        :label="$t('addConfigModule.serviceClassification')"
        width="100"
        align="center"
        v-if="!configurationGroup.isService"
      />
      <el-table-column :label="$t('addConfigModule.more')" width="80" align="center">
        <template slot-scope="scope">
          <MoreContent :scope="scope" :is-partner="isPartner" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
// xe-utils 函数库
import XEUtils from 'xe-utils';
import longText from '../quotationlist/longText';
import MoreContent from '../components/PreciseMoreContent';
import eventBus from '@/utils/eventBus';
import { isNotNull, isPartnerM, notesTextFormat } from '@/utils/mUtils';
import PreciseProductNameFormation from '../components/PreciseProductNameFormation';
import ProductStatusFomation from '../components/ProductStatusFomation';
import ProductTypeFormation from '../components/ProductTypeFormation';
import Api from '../../api';
// import TemplateList from '../templ/TemplateList';
import { changeStyle } from '@/utils/numberFormater';
export default {
  props: {
    data: {
      type: Array,
      default: function () {
        return [];
      }

    },
    configurationGroup: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  components: {
    // TemplateList,
    longText,
    MoreContent,
    PreciseProductNameFormation,
    ProductStatusFomation,
    ProductTypeFormation
  },
  data () {
    return {
      search: '',
      switchFlgP: true,
      isPartner: true,
      tableData: [],
      tableDataTmp: [],
      expandKeys: [],
      popoverObj: {}
    };
  },
  watch: {
    data () {
      this.$nextTick(() => {
        this.tableDataTmp = JSON.parse(JSON.stringify(this.data));
        this.tableData = [...this.tableDataTmp];
        this.handleSearch();
        this.expandKeys = [];
        XEUtils.eachTree(this.data, item => {
          if (!item.hasChildren) {
            this.expandKeys.push(item.nodeId);
          }
        });
      });
    }
  },
  mounted () {
    this.isPartner = isPartnerM();
  },
  methods: {
    isNotNull,
    notesTextFormat,
    changeStyle,

    handlePopover (item, productCode) {
      console.log(item);
      console.log(productCode);
      this.replaceProductModelAxios(productCode, item);
    },
    async replaceProductModelAxios (productCode, item) {
      try {
        const result = await Api.replaceProductModel(productCode, item);
        console.log(result.data);
        if (result.data.status === '200') {
          this.popoverObj = result.data.data[0];
          this.popoverObj.newShelfTime = this.popoverObj.newShelfTime.substr(0, 10);
        } else {
          this.$notify.error(result.data.err);
        }
      } catch (e) {
        console.log(e);
      }
    },
    saveUserProductAlias (item) {
      let body = {
        productCode: item.productCode,
        subId: item.subId,
        alias: item.alias
      };
      Api.saveUserProductAlias(body).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.$message({
            showClose: true,
            duration: 800,
            message: this.$t('addConfigModule.editProductNameSuccess'),
            type: 'success'
          });
        }
      }).catch(e => {
        this.$notify.error(this.$t('addConfigModule.networkAnomaly'));
      });
    },
    reset () {
      this.search = '';
      this.tableData = [];
      this.expandKeys = [];
    },
    clear () {
      // this.tableData = JSON.parse(JSON.stringify(this.data));
      this.tableData = this.tableDataTmp;
    },
    handleSearch () {
      let filterName = (XEUtils.toString(this.search).trim()).toLowerCase();
      if (filterName) {
        let options = { children: 'children' };
        let searchProps = ['nodeName'];
        let searchProps1 = ['productDesc'];
        this.tableData = XEUtils.searchTree(
          this.tableDataTmp,
          item =>
            searchProps.some(
              key => XEUtils.toString(item[key].toLowerCase()).indexOf(filterName) > -1
            ) || searchProps1.some(
              key => XEUtils.toString(item.productInitListVO && item.productInitListVO[key].toLowerCase()).indexOf(filterName) > -1
            ),
          options
        );
      } else {
        // this.tableData = JSON.parse(JSON.stringify(this.data));
        this.tableData = this.tableDataTmp;
      }
    },
    // 创建一个防反跳策略函数，调用频率间隔 200 毫秒
    searchEvent: XEUtils.debounce(
      function () {
        this.handleSearch();
      },
      200,
      { leading: false, trailing: true }
    ),
    priceFormat (row, column, cellValue) {
      if (row.isRiil && row.retailPriceFloatingRate > 0) {
        if (row.retailPriceFloatingRate > 0) {
          return 'list*' + row.retailPriceFloatingRate;
        }
      }
      if (row.lineId === 25) {
        if (row.productPrice < 1 || row.productPrice == null) {
          if (row.sprPriceRatio != null) {
            return row.sprPriceRatio;
          } else {
            return row.productPrice;
          }
        }
      }
      return this.formatePrice(cellValue);
    },
    formatePrice (cellValue) {
      if (cellValue === 0) {
        return 0;
      }
      if (cellValue) {
        let value = Number(cellValue).toFixed(2);
        let intPart = Math.trunc(value);
        let intPartFormat = intPart
          .toString()
          .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        let value2Array = value.toString().split('.');
        if (value2Array.length === 2) {
          let floatPart = value2Array[1]; // 拿到小数部分
          intPartFormat = intPartFormat + '.' + floatPart;
          return intPartFormat;
        } else {
          return intPartFormat;
        }
      }
    },
    foo (h, { column }) {
      if (column.label) {
        return h('span', {}, [
          h('span', [column.label]),
          h(
            'button',
            {
              attrs: {
                style:
                  'float:right;color:#3fbbdc;border:none;border-radius:5px;height:2rem'
              },
              on: {
                click: () => {
                  this.expandDiscribe();
                }
              }
            },
            [this.$t('addConfigModule.expandOrCloseAll')]
          )
        ]);
      }
    },
    expandDiscribe () {
      // longText.expandDisc();
      this.switchFlgP = !this.switchFlgP;
      eventBus.$emit('longTextDisc');
    },
    toProductQualificationList (productName) {
      let routeData = this.$router.resolve({
        name: 'ProductQualificationList',
        query: { productName: productName }
      });
      window.open(routeData.href, '_blank');
    },
    // 递归遍历树节点
    filterTree (nodes, predicate, childKey = 'children') {
      // predicate过滤条件函数
      if (!nodes || !nodes.length) return 0;
      const children = [];
      for (let node of nodes) {
        node = Object.assign({}, node);
        const sub = this.filterTree(node[childKey], predicate, childKey);
        if ((sub && sub.length) || predicate(node)) {
          sub && (node[childKey] = sub);
          children.push(node);
        }
      }
      return children.length ? children : 0;
    },
    // 过滤的条件
    filterNode (data) {
      return (
        !this.search ||
        data.nodeName.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    load (tree, treeNode, resolve) {
      this.$emit('load', tree, treeNode, resolve);
    },
    tableRowClassName ({ row }) {
      if (row.nodeLevel === 2) {
        return 'highlight-row';
      }
    }
  }
};
</script>

<style lang="scss">
.add-product-table {
   margin-top: 0;
  margin-bottom: 0;
  .highlight-row {
    background-color: #f0f9eb;
    // background-color: #36BADE;
  }
  .el-button--primary:hover {
    color: #fff;
    background-color: #60c8e8 !important;
    border-color: #60c8e8 !important;
  }

  .clear {
    clear: both;
  }

  .el-form-item {
    float: left;
    margin-right: 0;
    margin-bottom: 0;
    height: 3rem;
  }

  .el-table .cell {
    white-space: normal;
  }

  /*设置描述*/

  .cell:hover .el-tag {
    border: 1px solid #36bade;
  }

  .el-tag {
    text-overflow: ellipsis;
    display: inline-block;
    border: transparent;
    margin: 0;
    cursor: pointer;
  }

  .el-tag img {
    width: 24px;
  }

  .dialog-footer {
    margin-top: 20px;
    text-align: center;
  }

  .head-section el-icon-edit-outline {
    vertical-align: middle;
  }
  .el-table__body-wrapper {
    overflow-y: auto !important;
  }

  @media screen and (max-width: 1366px) {
    table * {
      margin: 0;
      padding: 0;
      margin-bottom: 0;
    }

    .tab-p {
      margin-top: 0;
    }
  }
  .checked {
    /*width: 115px;*/
    background: #00a0e9;
    margin: 0 auto;
    /*color: red;*/
  }
}

</style>
